import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ResultListApiModel} from "../models/result-list.api.model";
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {plainToClass, plainToClassFromExist} from "class-transformer";
import {ViolationApiModel} from "../models/violation.api-model";
import {QueryParamsService} from "../../core/services/query-params.service";
import {QueryParamsApiModel} from "../models/query-params-api.model";

@Injectable()
export class ViolationRestService {
  private readonly resource: string = '/violations';

  constructor(
    private http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public create(violationAM: ViolationApiModel): Observable<ViolationApiModel> {
    return this.http.post<ViolationApiModel>(environment.apiUrl + this.resource, violationAM)
      .pipe(map((result: ViolationApiModel) => plainToClass(ViolationApiModel, result)))
  }

  public put(violationAM: ViolationApiModel): Observable<ViolationApiModel> {
    return this.http.put<ViolationApiModel>(environment.apiUrl + violationAM['@id'], violationAM)
      .pipe(map((result: ViolationApiModel) => plainToClass(ViolationApiModel, result)))
  }

  public get(id: string, queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ViolationApiModel> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ViolationApiModel>(environment.apiUrl + this.resource + '/' + id, {params})
      .pipe(map((result: ViolationApiModel) => plainToClass(ViolationApiModel, result)))
  }

  public getCollection(): Observable<ResultListApiModel<ViolationApiModel>> {
    return this.http.get<ResultListApiModel<ViolationApiModel>>(environment.apiUrl + this.resource)
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<ViolationApiModel>(ViolationApiModel), result as object)));
  }

  public getUserSubResourceCollection(userId: string): Observable<ResultListApiModel<ViolationApiModel>> {
    return this.http.get<ResultListApiModel<ViolationApiModel>>(environment.apiUrl+ userId + this.resource)
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<ViolationApiModel>(ViolationApiModel), result as object)));
  }
}
